import { IconAngleLeft } from '@iwoca/icons';
import { NEW_IwLink } from '@iwRouter/NEW_IwLink';
import { FormattedMessage } from 'react-intl';

export const BackToDashboard = () => {
    return (
        <NEW_IwLink
            to={{
                pathname: '/'
            }}
            className="my-xl text-s"
        >
            <IconAngleLeft />
            <FormattedMessage
                id="_.navigation.return_to_dashboard"
                defaultMessage="Return to dashboard"
            />
        </NEW_IwLink>
    );
};
